import { createFileRoute } from "@tanstack/react-router";
import CocaineAddictionTreatmentNJ from "@/pages/CocaineAddictionTreatmentNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/cocaine-addiction-treatment-nj")({
  head: () => routeHead("/cocaine-addiction-treatment-nj"),
  component: CocaineAddictionTreatmentNJ,
});
